export const ERROR_HANDLER = "portail/ERROR_HANDLER";
export const AUTH_LOGIN = "auth/LOGIN";
export const AUTH_LOGOUT = "auth/AUTH_LOGOUT";
export const AUTH_GET_TOKEN = "auth/AUTH_GET_TOKEN";
export const AUTH_SET_IDENTITY = "auth/AUTH_SET_IDENTITY";
export const SET_IDENTITY_USER = "user/SET_IDENTITY_USER";
export const SIDEBAR_COLLAPSE = "layout/SIDEBAR_COLLAPSE";
export const GET_UPSELL_TOKEN_FROM_GOOGLE = "auth/GET_UPSELL_TOKEN_FROM_GOOGLE";
export const GET_UPSELL_TOKEN_FROM_MICROSOFT = "auth/GET_UPSELL_TOKEN_FROM_MICROSOFT";
export const SET_UPSELL_TOKEN = "auth/SET_UPSELL_TOKEN";
export const GET_CURRENT_USER_INFOS = "auth/GET_CURRENT_USER_INFOS";
export const SET_CURRENT_USER_INFOS = "auth/SET_CURRENT_USER_INFOS";
export const SET_CURRENT_CLIENT = "auth/SET_CURRENT_CLIENT";
export const GET_ALL_SECTORS_LIST = "GET_ALL_SECTORS_LIST";
export const SET_ALL_SECTORS_LIST = "SET_ALL_SECTORS_LIST";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
// Error for Login
export const ERROR_STATUS_LOGIN = "user/ERROR_STATUS_LOGIN";
export const NOTIFICATION_STATUS_LOGIN = "user/NOTIFICATION_STATUS_LOGIN";


// PHOTOTHEQUE
export const PHOTOTHEQUE_INIT = "phototheque/INIT";
export const PHOTOTHEQUE_GET_FILTERS = "phototheque/GET_FILTERS";
export const PHOTOTHEQUE_ADD_BEST_FLAG = "phototheque/ADD_BEST_FLAG";
export const PHOTOTHEQUE_REMOVE_BEST_FLAG = "phototheque/REMOVE_BEST_FLAG";
export const PHOTOTHEQUE_GET_MEDIAS = "phototheque/GET_MEDIAS";
export const PHOTOTHEQUE_SET_MEDIAS = "phototheque/SET_MEDIAS";
export const PHOTOTHEQUE_SET_PAGINATION = "phototheque/SET_PAGINATION";
export const PHOTOTHEQUE_GET_DYNAMIQUE_FILTER_VALUES = "phototheque/GET_DYNAMIQUE_FILTER_VALUES";
export const PHOTOTHEQUE_SET_CURRENT_FILTERS = "phototheque/SET_CURRENT_FILTERS";
export const PHOTOTHEQUE_SET_FILTERS = "phototheque/SET_FILTERS";

export const PHOTOTHEQUE_ADD_CURRENT_FILTERS = "phototheque/PHOTOTHEQUE_ADD_CURRENT_FILTERS";
export const PHOTOTHEQUE_FILTERS_LOADING = "phototheque/FILTERS_LOADING";
export const PHOTOTHEQUE_MEDIAS_LOADING = "phototheque/MEDIAS_LOADING";
export const PHOTOTHEQUE_SET_FLAG_MEDIA = "phototheque/SET_FLAG_MEDIA";
export const PHOTOTHEQUE_SET_KEY_FILTER_SELECTED = "phototheque/SET_KEY_FILTER_SELECTED";
export const PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS = "PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS";
// VISIT
export const VISIT_GET = "visit/GET";
export const VISIT_ADD_CURRENT_FILTERS = "visit/VISIT_ADD_CURRENT_FILTERS";
export const VISIT_SET_FILTERS = "visit/SET_FILTERS";
export const VISIT_SET_VISITS = "visit/SET_VISITS";
export const VISIT_SET_CURRENT_FILTERS = "visit/SET_CURRENT_FILTERS";
export const VISIT_SET_PAGINATION = "visit/SET_PAGINATION";
export const VISIT_INIT = "visit/INIT";
export const VISIT_FILTERS_LOADING = "visit/FILTERS_LOADING";
export const VISIT_VISITS_LOADING = "visit/VISITS_LOADING";
export const VISIT_GET_DYNAMIQUE_FILTER_VALUES = "visit/GET_DYNAMIQUE_FILTER_VALUES"; //TODO Remove once phototheque is updated
export const VISIT_SET_SORT = "visit/SET_SORT";
export const VISIT_SET_KEY_FILTER_SELECTED = "visit/SET_KEY_FILTER_SELECTED";

// USER
export const USER_SET_SECTORS_LIST = "user/USER_SET_SECTORS_LIST";
export const USER_GET_SECTORS_LIST = "user/USER_GET_SECTORS_LIST";
export const UPDATE_USER_SECTOR = "user/UPDATE_USER_SECTOR";
export const UPDATE_USER_KPIS = "user/UPDATE_USER_KPIS";
export const UPDATE_USER_KPILIST = "UPDATE_USER_KPILIST";
export const UPDATE_USER_ROLE = "user/UPDATE_USER_ROLE";
export const SET_ROLES_LIST = "user/SET_ROLES_LIST";
export const GET_ROLES_LIST = "user/GET_ROLES_LIST";
export const UPDATE_USERS_LIST = "user/UPDATE_USERS_LIST";
export const UPDATE_ACL_SERVICE_CLIENT = "user/UPDATE_ACL_SERVICE_CLIENT";
export const SET_ACL_LIST = "user/SET_ACL_LIST";
export const GET_ACL_LIST = "user/GET_ACL_LIST";
export const SET_SERVICES_LIST = "user/SET_SERVICES_LIST";
export const GET_SERVICES_LIST = "user/GET_SERVICES_LIST";
export const UPDATE_USER_CLIENTS = "user/UPDATE_USER_CLIENTS";
export const USER_SET_ALL_CLIENTS = "user/USER_SET_ALL_CLIENTS";
export const USER_GET_ALL_CLIENTS = "user/USER_GET_ALL_CLIENTS";
export const USER_GET = "user/GET";
export const USER_GET_FILTERS = "user/GET_FILTERS";
export const USER_SET_FILTERS = "user/SET_FILTERS";
export const USER_SET_USERS = "user/SET_USERS";
export const USER_GET_MISSION_FILTERS = "user/GET_MISSION_FILTERS";
export const USER_SET_CURRENT_FILTERS = "user/SET_CURRENT_FILTERS";
export const USER_ADD_CURRENT_FILTERS = "user/ADD_CURRENT_FILTERS";
export const USER_SET_PAGINATION = "user/SET_PAGINATION";
export const USER_INIT = "user/INIT";
export const USER_MISSION_FILTERS_LOADING = "user/MISSION_FILTERS_LOADING";
export const USER_FILTERS_LOADING = "user/FILTERS_LOADING";
export const USER_SET_MISSION_FILTERS = "user/SET_MISSION_FILTERS";
export const USER_USERS_LOADING = "user/USERS_LOADING";
export const USER_UPDATE_LOADING = "USER_UPDATE_LOADING";
export const USER_GET_DYNAMIQUE_FILTER_VALUES = "user/GET_DYNAMIQUE_FILTER_VALUES";
export const USER_SET_SORT = "user/SET_SORT";
export const USER_SET_KEY_FILTER_SELECTED = "user/SET_KEY_FILTER_SELECTED";
// CLIENT
export const ADD_IMPORT_CLIENT = "kpi/ADD_IMPORT_CLIENT";
export const ADD_IMPORT_SECTOR = "ADD_IMPORT_SECTOR";
export const ADD_IMPORT_ASSORTMENTS = "ADD_IMPORT_ASSORTMENTS";
export const ADD_IMPORT_KPI = "kpi/ADD_IMPORT_KPI";
export const IMPORT_FILE = "import/FILE";
export const GET_ALL_CLIENT = "client/GET_ALL_CLIENT";
export const GET_ALL_RETAILER = "retailer/GET_ALL_RETAILER";

// PLANNING

export const CREATE_EVENT = "agenda/CREATE_EVENT";
export const UPDATE_EVENT = "agenda/UPDATE_EVENT";
export const DELETE_EVENT = "agenda/DELETE_EVENT";
export const UPDATE_VALIDATION_MANAGER = "agenda/UPDATE_VALIDATION_MANAGER";
export const SELECT_SECTOR = "agenda/SELECT_SECTOR";
export const SELECT_SELECTPDC = "agenda/SELECT_SELECTPDC";
export const SELECT_EMAIL = "agenda/SELECT_EMAIL";
export const SELECT_EVENT = "agenda/SELECT_EVENT";
export const IS_LOADING = "agenda/IS_LOADING";
export const DISPLAY_PDC_FORM = "agenda/DISPLAY_PDC_FORM";

// SURVEY
export const SURVEY_SET_CURRENT_TITLE = "survey/SURVEY_SET_CURRENT_TITLE";
export const GET_ARCHIVE_SURVEY = "survey/GET_ARCHIVE_SURVEY";
export const SET_ARCHIVE_SURVEY = "survey/SET_ARCHIVE_SURVEY";
export const SET_SURVEY_SORT = "survey/SET_SURVEY_SORT";
export const SET_KEY_SURVEY_FILTER_SELECTED = "survey/SET_KEY_SURVEY_FILTER_SELECTED";
export const SET_SURVEY_LIST = "survey/SET_SURVEY_LIST";
export const SURVEY_SET_PAGINATION = "survey/SET_PAGINATION";
export const SURVEY_SET_FILTERS = "survey/SET_FILTERS";
export const SURVEY_GET_DYNAMIQUE_FILTER_VALUES = "survey/GET_DYNAMIQUE_FILTER_VALUES";
export const SURVEY_SET_CURRENT_FILTERS = "survey/SET_CURRENT_FILTERS";
export const GET_KPIS_LIST = "kpi/GET_KPIS_LIST";
export const GET_QUESTIONS_BY_KPI = "kpi/GET_QUESTIONS_BY_KPI";
export const GET_ALL_KPI_QUESTIONS_LIST = "kpi/GET_ALL_KPI_QUESTIONS_LIST";
export const GET_SURVEY_LIST = "kpi/GET_SURVEY_LIST";
export const GET_SECTORS_LIST = "kpi/GET_SECTORS_LIST";
export const ADD_KPIS_LIST = "kpi/ADD_KPIS_LIST";
export const DELETE_KPIS_LIST = "kpi/DELETE_KPIS_LIST";
export const UPDATE_KPI_QUESTIONS_LIST = "kpi/UPDATE_KPI_QUESTIONS_LIST";
export const SURVEY_PROGRESS_STEPS = "kpi/SURVEY_PROGRESS_STEPS";
export const ADD_SURVEY_ELEMENT = "survey/ADD_SURVEY_ELEMENT";
export const GET_ALL_MODEL_BY_ID = "survey/GET_ALL_MODEL_BY_ID";
export const GET_ALL_LOCATION = "survey/GET_ALL_LOCATION";
export const GET_ALL_SECTOR = "survey/GET_ALL_SECTOR";
export const GET_SURVEY_SECTORS_LIST = "survey/GET_SURVEY_SECTORS_LIST";
export const GET_SURVEY_ENSEIGNES_LIST = "survey/GET_SURVEY_ENSEIGNES_LIST";
export const GET_SURVEY_MODELES_LIST = "survey/GET_SURVEY_MODELES_LIST";
export const GET_RETAILER_BY_IDRETAILER_IDCLIENT = "survey/GET_RETAILER_BY_IDRETAILER_IDCLIENT";
export const SURVEY_UPDATE_LOCATION_TYPES = "survey/SURVEY_UPDATE_LOCATION_TYPES";
export const SURVEY_SET_PROGRESS = "survey/SURVEY_SET_PROGRESS";
export const SURVEY_SET_CURRENT_MODEL = "survey/SURVEY_SET_CURRENT_MODEL";
export const SIMULATION_INIT = "survey/SIMULATION_INIT";
export const SIMULATION_SET_GENERATED = "survey/SIMULATION_SET_GENERATED";
export const SIMULATION_SET_LTN = "survey/SIMULATION_SET_LTN";
export const SIMULATION_SET_KPI_PAGE = "survey/SIMULATION_SET_KPI_PAGE";
export const SIMULATION_SET_LN = "survey/SIMULATION_SET_LN";
export const SIMULATION_SET_SN = "survey/SIMULATION_SET_SN";
export const SIMULATION_SET_FIRTPAGE = "survey/SIMULATION_SET_FIRTPAGE";
export const SIMULATION_SET_SURVEYON = "survey/SIMULATION_SET_SURVEYON";
export const SIMULATION_SET_JSON = "survey/SIMULATION_SET_JSON";
export const SIMULATION_SET_SURVEY_ANSWERS = "survey/SIMULATION_SET_SURVEY_ANSWERS";
export const SIMULATION_SET_PAGINATION_STATE = "survey/SIMULATION_SET_PAGINATION_STATE";
export const SIMULATION_SET_LOCATION_TYPES = "survey/SIMULATION_SET_LOCATION_TYPES";
export const SIMULATION_SET_EMPLACEMENT_LOCATIONS_TYPES = "survey/SIMULATION_SET_EMPLACEMENT_LOCATION_TYPES";
export const SIMULATION_RESET = "survey/SIMULATION_RESET";
export const SIMULATION_RESET_PAGINATION = "survey/SIMULATION_RESET_PAGINATION";
export const SIMULATION_GOTO_LOCATION_TYPES = "survey/SIMULATION_GOTO_LOCATION_TYPES";
export const UPDATE_SURVEY = "survey/UPDATE_SURVEY";
export const SURVEY_DELETE = "survey/DELETE_SURVEY";
export const ADD_ELEMENT_MLAB = "user/ADD_ELEMENT_MLAB";
export const GET_ALL_USER_MLAB = "user/GET_ALL_USER_MLAB";
export const GET_CURRENT_USER_MLAB = "user/GET_CURRENT_USER_MLAB";
export const SURVEY_CREATION_SET_KPISLIST = "survey/CREATION_SET_KPISLIST";
export const SURVEY_CREATION_SET_ACTIONSLIST = "survey/CREATION_SET_ACTIONSLIST";
export const SURVEY_CREATION_SET_ACTIONTYPES = "survey/CREATION_SET_ACTIONTYPES";
export const SURVEY_CREATION_SET_SECTORSLIST = "survey/CREATION_SET_SECTORSLIST";
export const SURVEY_CREATION_SET_MODELSLIST = "survey/CREATION_SET_MODELSLIST";
export const SURVEY_PROGRESS_ADD_END_VISIT_STATEMENT = "survey/PROGRESS_ADD_END_VISIT_STATEMENT";
export const SURVEY_PROGRESS_REMOVE_END_VISIT_STATEMENT = "survey/PROGRESS_REMOVE_END_VISIT_STATEMENT";
export const SURVEY_SET_LIST_LOADING = "survey/SET_LIST_LOADING";

//PLANNING
export const PLANNING_SET_AVAILABLE_DATE_RANGE = "planning/PLANNING_SET_AVAILABLE_DATE_RANGE";
export const PLANNING_GET_AVAILABLE_DATE_RANGE = "planning/PLANNING_GET_AVAILABLE_DATE_RANGE";
export const PLANNING_SET_KEY_SECTOR_FILTER_SELECTED = "planning/PLANNING_SET_KEY_SECTOR_FILTER_SELECTED";
export const PLANNING_SET_KEY_PDC_FILTER_SELECTED = "planning/PLANNING_SET_KEY_PDC_FILTER_SELECTED";
export const PLANNING_SET_REQUEST_RESPONSE = "planning/PLANNING_SET_REQUEST_RESPONSE";
export const PLANNING_UPDATE_EVENT = "planning/PLANNING_UPDATE_EVENT";
export const PLANNING_MOVE_DAY_EVENTS = "planning/PLANNING_MOVE_DAY_EVENTS";
export const PLANNING_SET_KEY_FILTER_SELECTED = "planning/SET_KEY_FILTER_SELECTED,";
export const PLANNING_SET_CURRENT_DATE_RANGE = "PLANNING_SET_CURRENT_DATE_RANGE";
export const PLANNING_SET_LUCCA_VACATION_DAYS = "PLANNING_SET_LUCCA_VACATION_DAYS";
export const PLANNING_SELECT_USER_TYPEVISIT = "planning/SELECT_USER_TYPEVISIT";
export const PLANNING_GET_ALL_SECTORSLIST = "planning/GET_ALL_SECTORSLIST";
export const PLANNING_SET_ALL_SECTORSLIST = "planning/SET_ALL_SECTORSLIST";
export const PLANNING_SET_CURRENT_FILTERS = "planning/SET_CURRENT_FILTERS";
export const PLANNING_SELECT_USER_SECTOR = "planning/SELECT_USER_SECTOR";
export const PLANNING_GET_USER_PDCSLIST = "planning/GET_USER_PDCSLIST";
export const PLANNING_SET_USER_PDCSLIST = "planning/SET_USER_PDCSLIST";
export const PLANNING_GET_TYPES_VISIT = "planning/GET_TYPES_VISIT";
export const PLANNING_SET_TYPES_VISIT = "planning/SET_TYPES_VISIT";
export const PLANNING_SELECT_USER_PDC = "planning/SELECT_USER_PDC";
export const PLANNING_PRE_SELECT_USER = "planning/PRE_SELECT_USER";
export const PLANNING_AGENDA_LOADING = "planning/AGENDA_LOADING";
export const PLANNING_SEND_NEW_EVENT = "planning/SEND_NEW_EVENT";
export const PLANNING_MODAL_LOADING = "planning/MODAL_LOADING";
export const PLANNING_SELECT_EMAIL = "planning/SELECT_EMAIL";
export const PLANNING_SELECT_DATE = "PLANNING_SELECT_DATE";
export const PLANNING_DELETE_EVENT = "planning/DELETE_EVENT";
export const PLANNING_SET_FILTERS = "planning/SET_FILTERS";
export const PLANNING_SELECT_USER = "planning/SELECT_USER";
export const PLANNING_SET_EVENTS = "planning/SET_EVENTS";
export const PLANNING_SELECT_PDC_ID = "PLANNING_SELECT_PDC_ID";
export const PLANNING_GET_EVENT_TYPES = "PLANNING_GET_EVENT_TYPES";
export const PLANNING_SET_EVENT_TYPES = "PLANNING_SET_EVENT_TYPES";

//MODELS
export const MODELS_SET_LIST = "models/MODELS_SET_LIST";
export const MERCH_SET_LIST = "models/MERCH_SET_LIST";
//SECTORS
export const SECTORS_UPDATE_LIST = "sectors/SECTORS_UPDATE_LIST";
export const SECTORS_SET_LIST = "sectors/SECTORS_SET_LIST";
export const SECTORS_GET_MANAGER_USERS_LIST = "sectors/SECTORS_GET_MANAGER_USERS_LIST";
export const SECTORS_SET_MANAGER_USERS_LIST = "sectors/SECTORS_SET_MANAGER_USERS_LIST";
export const SECTORS_SET_PAGINATION = "sectors/SECTORS_SET_PAGINATION";
export const SECTORS_REMOVE_PDC = "sectors/SECTORS_REMOVE_PDC";
export const SECTORS_GET_PDCS = "sectors/SECTORS_GET_PDCS";
export const SECTORS_ADD_PDC = "sectors/SECTORS_ADD_PDC";
export const SECTORS_SET_PDCS = "sectors/SECTORS_SET_PDCS";
export const SECTORS_SET_ALL = "sectors/SECTORS_SET_ALL";

export const PDC_SET_KEY_FILTER_SELECTED = "PDC_SET_KEY_FILTER_SELECTED";
export const PDC_SET_CURRENT_FILTERS = "PDC_SET_CURRENT_FILTERS";
export const PDC_ADD_CURRENT_FILTERS = "PDC_ADD_CURRENT_FILTERS";
export const PDC_SET_PAGINATION = "PDC_SET_PAGINATION";
export const PDC_SET_METRICS = "PDC_SET_METRICS";
export const PDC_SET_FILTERS = "PDC_SET_FILTERS";
export const PDC_SET_RANGES = "PDC_SET_RANGES";
export const PDC_FILTERS_LOADING = "PDC_FILTERS_LOADING";
export const PDC_SET_LIST = "PDC_SET_LIST";
export const PDC_SET_SORT = "PDC_SET_SORT";
export const PDC_SET_PDC = "PDC_SET_PDC";
export const PDC_GET_PDC = "PDC_GET_PDC";
export const PDC_INIT = "PDC_INIT";
//KPIS
export const KPIS_SET_LIST = "kpis/KPIS_SET_LIST";
export const KPIS_SET_MATCH_FILTERS = "KPIS_SET_MATCH_FILTERS";

//ACTIONS
export const ACTIONS_SET_LIST = "actions/ACTIONS_SET_LIST";

//IOCS
export const IOCS_SET_LIST = "iocs/IOCS_SET_LIST";

//NETWORK
export const NETWORKS_SET_LIST = "network/NETWORKS_SET_LIST";

//CLIENTS
export const CLIENTS_SET_LIST = "clients/CLIENTS_SET_LIST";

//TYPOLOGIES
export const TYPOLOGIES_SET_LIST = "typologies/TYPOLOGIES_SET_LIST";

//PROPRIETES
export const PROPERTIES_SET_LIST = "properties/PROPERTIES_SET_LIST";

export const COMMERCIAL_PERIODS_SET_LIST = "commercial/COMMERCIAL_PERIODS_SET_LIST";
export const COMMERCIAL_DELETE = "commercial/COMMERCIAL_DELETE";
export const COMMERCIAL_UPDATE = "commercial/COMMERCIAL_UPDATE";
export const COMMERCIAL_CREATE = "commercial/COMMERCIAL_CREATE";
//REFERENTIELS
export const REFERENTIELS_SET_PAGINATION = "referentiels/REFERENTIELS_SET_PAGINATION";
export const REFERENTIELS_SET_SORT = "referentiels/REFERENTIELS_SET_SORT";
export const REFERENTIELS_SET_MATCH = "REFERENTIELS_SET_MATCH";

export const LOG_GET = "log/GET";
export const LOG_ADD_CURRENT_FILTERS = "log/LOG_ADD_CURRENT_FILTERS";
export const LOG_SET_FILTERS = "log/SET_FILTERS";
export const LOG_SET_LOGS = "log/SET_LOGS";
export const LOG_SET_CURRENT_FILTERS = "log/SET_CURRENT_FILTERS";
export const LOG_SET_PAGINATION = "log/SET_PAGINATION";
export const LOG_INIT = "log/INIT";
export const LOG_FILTERS_LOADING = "log/FILTERS_LOADING";
export const LOG_LOGS_LOADING = "log/LOGS_LOADING";
export const LOG_GET_DYNAMIQUE_FILTER_VALUES = "log/GET_DYNAMIQUE_FILTER_VALUES"; //TODO Remove once phototheque is updated
export const LOG_SET_SORT = "log/SET_SORT";
export const LOG_SET_KEY_FILTER_SELECTED = "log/SET_KEY_FILTER_SELECTED";

//ADMIN - PREMIUM
export const GET_PREMIUM_LIST = "GET_PREMIUM_LIST";
export const SET_PREMIUM_LIST = "SET_PREMIUM_LIST";
export const GET_LIMITS_BONUSES = "GET_LIMITS_BONUSES";
export const SET_LIMITS_BONUSES_LIST = "SET_LIMITS_BONUSES_LIST";
export const GET_REGULAR_BONUSES = "GET_REGULAR_BONUSES";
export const SET_REGULAR_BONUSES_LIST = "SET_REGULAR_BONUSES_LIST";

export const GET_USERS_SECTORS_LIST = "GET_USERS_SECTORS_LIST";
export const SET_USERS_SECTORS_LIST = "SET_USERS_SECTORS_LIST";



// WEBPACK FOOTER //
// src/redux/types.js